import {
    types,
    stepTypes,
    errorMessageTypes,
} from '../actions/IdVerificationActions';
import {
    IdVerificationStatus,
} from '../services/idverification/IdVerificationConstants';

const defaultState = {
    currentStep: stepTypes.PHOTO,
    hasPhoto: false,
    consecutiveRejections: 0,
    verificationStatus: null,
    idVerificationStatus: IdVerificationStatus.NOT_SET,
    photoRetakeCompleted: false,
    manualIdVerificationRequestSent: false,
};

function idverificationReducer(state = defaultState, action) {
    switch (action.type) {
    case types.IDVERIFICATION_TAKE_PHOTO:
        return {
            ...state,
            hasPhoto: true,
            verificationStatus: errorMessageTypes.loading,
        };

    case types.IDVERIFICATION_PHOTO_APPROVED:
        return {
            ...state,
            consecutiveRejections: defaultState.consecutiveRejections,
            verificationStatus: errorMessageTypes.none,
        };

    case types.IDVERIFICATION_REQUEST_WENT_WRONG:
        return {
            ...state,
            verificationStatus: errorMessageTypes.requestWentWrong,
        };

    case types.IDVERIFICATION_PHOTO_REJECTED:
        return {
            ...state,
            consecutiveRejections: (state.consecutiveRejections || 0) + 1,
            verificationStatus: action.verificationStatus,
        };

    case types.IDVERIFICATION_SIMILARITY_UPDATE:
        return {
            ...state,
            verificationStatus: action.verificationStatus,
        };

    case types.IDVERIFICATION_CHANGE_STEP:
        return {
            ...state,
            currentStep: action.newStep,
            hasPhoto: defaultState.hasPhoto,
            consecutiveRejections: defaultState.consecutiveRejections,
            verificationStatus: action.verificationStatus,
        };

    case types.IDVERIFICATION_SET_ID_VERIFICATION_STATUS: {
        if (Object.values(IdVerificationStatus).indexOf(action.idVerificationStatus) < 0) {
            return state;
        }

        const newState = {
            idVerificationStatus: action.idVerificationStatus,
            idVerificationStatusSetTime: action.idVerificationStatusSetTime,
        };

        if (action.idVerificationStatus === IdVerificationStatus.REQUIRES_PHOTO_RETAKE) {
            newState.photoRetakeCompleted = false;
        }

        return {
            ...state,
            ...newState,
        };
    }

    case types.IDVERIFICATION_MANUAL_VERIFICATION_REQUEST_SENT:
        return {
            ...state,
            manualIdVerificationRequestSent: action.isSent,
        };

    case types.IDVERIFICATION_PHOTO_RETAKE_COMPLETED:
        return {
            ...state,
            photoRetakeCompleted: action.isCompleted,
        };

    default:
        return state;
    }
}

export default idverificationReducer;
